// extracted by mini-css-extract-plugin
module.exports = {"p1s67rcg":"p1s67rcg","align-center":"align-center"};